import React from 'react';
import { useTranslation } from 'react-i18next';
import { URLS, Url } from '@wix/da-url';
import Button from '../../../Button';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { BiData } from '@wix/da-bi/pkg/events';
import s from './UserSymbolsFooter.scss';
const UserSymbolsFooter = ({ isLoggedIn, hasCoreMembership, requestClose })=>{
    const { t } = useTranslation();
    const isCoreFooter = isLoggedIn && hasCoreMembership;
    const isLoggedInFooter = isLoggedIn && !hasCoreMembership;
    const isLoggedOutFooter = !isLoggedIn;
    const membershipUrl = `${URLS.CORE_MEMBERSHIP}?point=username_symbol_modal`;
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, isCoreFooter && /*#__PURE__*/ React.createElement(Button, {
        className: s['confirm-btn'],
        view: "b1",
        height: "medium",
        fullWidth: false,
        onClick: requestClose,
        minWidth: '113px'
    }, t('userSymbolsPopup.v2.footer.core.button')), isLoggedInFooter && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: s['footer-headers']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['header']
    }, t('userSymbolsPopup.v2.footer.upgrade.title')), /*#__PURE__*/ React.createElement("div", {
        className: s['subheader']
    }, t('userSymbolsPopup.v2.footer.upgrade.text'))), /*#__PURE__*/ React.createElement(Button, {
        view: "b22",
        height: "medium",
        fullWidth: false,
        minWidth: '154px',
        href: membershipUrl,
        biData: BiData({
            evid: 375,
            referral_info: ReferralType.USER_SYMBOL_POPUP
        })
    }, t('userSymbolsPopup.v2.footer.upgrade.button'))), isLoggedOutFooter && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: s['footer-headers']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['header']
    }, t('userSymbolsPopup.v2.footer.signup.title')), /*#__PURE__*/ React.createElement("div", {
        className: s['subheader']
    }, t('userSymbolsPopup.v2.footer.signup.text'))), /*#__PURE__*/ React.createElement(Button, {
        view: "b1",
        height: "medium",
        fullWidth: false,
        minWidth: '215px',
        href: Url.joinLink('username_symbol_modal'),
        biData: BiData({
            evid: 240,
            referral_info: ReferralType.USER_SYMBOL_POPUP
        })
    }, t('userSymbolsPopup.v2.footer.signup.button'))));
};
UserSymbolsFooter.displayName = 'UserSymbolsFooter';
export default UserSymbolsFooter;

//# sourceMappingURL=UserSymbolsFooter.js.map